import { createRoutine } from "../../redux/utils/routine.utils";
export var requestLead = createRoutine("REQUEST_LEAD");
export var getLead = createRoutine("LEAD_GET");
export var updateLead = createRoutine("LEAD_UPDATE");
export var getLeadsPaged = createRoutine("LEADS_GET_PAGED");
